import React from 'react';
import Emoji from '../../svgIcons/dist/components/emoji';
import EmojiClose from '../../svgIcons/dist/components/emojiClose';
export var EmojiIcon = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.open, open = _c === void 0 ? false : _c, iconSize = _a.iconSize;
    return (React.createElement("span", { key: "emoji-button-style", "data-hook": "emoji-button-style", style: style },
        ' ',
        open ? React.createElement(EmojiClose, { size: iconSize }) : React.createElement(Emoji, { size: iconSize }),
        ' '));
};
//# sourceMappingURL=EmojiIcon.js.map